// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c3KR7{margin:50px 65px 20px 0px;display:flex;align-items:baseline}`, "",{"version":3,"sources":["webpack://./src/pages/instamart/campaign/details/widgets/StaleCandidateTable/StaleCandidateTable.module.scss"],"names":[],"mappings":"AAAA,OACI,yBAAA,CACA,YAAA,CACA,oBAAA","sourcesContent":[".tableSubHeader {\n    margin: 50px 65px 20px 0px;\n    display: flex;\n    align-items: baseline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableSubHeader": `c3KR7`
};
export default ___CSS_LOADER_EXPORT___;
